var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { useState, useEffect } from "react";
import { getQuickAuthCode, quickAuth } from "../../../services/user.service";
import { useAuth } from "../../../context/Auth";
import { AuthView } from "../../../components/views/auth/AuthView";
import { InfoModal } from "../../../components/views/modals/InfoModal";
import { useTranslation } from "react-i18next";
import { focusManager } from "../../../utils/Focus";
export var CaveaAuthScreen = function () {
    var t = useTranslation().t;
    var dispatch = useAuth().dispatch;
    var _a = useState(), code = _a[0], setCode = _a[1];
    var _b = useState(""), sid = _b[0], setSid = _b[1];
    var _c = useState(0), countDown = _c[0], setCountDown = _c[1];
    var _d = useState(false), runTimer = _d[0], setRunTimer = _d[1];
    var _e = useState(false), isModalVisible = _e[0], setIsModalVisible = _e[1];
    var onClose = function () {
        setCountDown(0);
        setIsModalVisible(false);
        focusManager.popLayer();
    };
    var padZero = function (num) {
        return num < 10 ? "0" + num : "" + num;
    };
    var seconds = padZero(String(countDown % 60));
    var minutes = padZero(String(Math.floor(countDown / 60)));
    var codeStart = String(code).slice(0, 3);
    var codeEnd = String(code).slice(3, 7);
    useEffect(function () {
        var timerId;
        if (runTimer) {
            getQuickAuthCode().then(function (res) {
                setCode(res.code);
                if (res.sid) {
                    setSid(res.sid);
                }
            }, function () {
                focusManager.pushLayer({ groupName: "modalView", index: 0 });
                setIsModalVisible(true);
            });
            setCountDown(60 * 5);
            timerId = setInterval(function () {
                setCountDown(function (prevState) {
                    return prevState - 1;
                });
            }, 1000);
        }
        return function () {
            clearInterval(timerId);
        };
    }, [runTimer]);
    useEffect(function () {
        if (countDown < 0 && runTimer) {
            setRunTimer(false);
            setCountDown(0);
        }
        else if (countDown >= 0 && !runTimer) {
            setRunTimer(true);
        }
    }, [countDown, runTimer]);
    useEffect(function () {
        if (code && sid) {
            var interval_1 = setInterval(function () {
                quickAuth(code, sid).then(function (user) {
                    if (user && user.id) {
                        dispatch({ type: "LOGIN", user: __assign({}, user) });
                    }
                });
            }, 5000);
            return function () {
                clearInterval(interval_1);
            };
        }
    }, [code, sid]);
    return (React.createElement("div", null,
        React.createElement(AuthView, { codeStart: codeStart, codeEnd: codeEnd, minutes: minutes, seconds: seconds }),
        isModalVisible && (React.createElement("div", { id: "modal-overlay", tabIndex: 0, className: "modal-overlay" },
            React.createElement(InfoModal, { text: t("auth.error"), onClose: onClose })))));
};



//////////////////
// WEBPACK FOOTER
// ./src/screens/AuthScreen/CaveaAuth/CaveaAuthScreen.tsx
// module id = 168
// module chunks = 1